<template>
    <section>
        <v-card elevation="10">
            <v-card-item v-if="title || data" class="py-4 px-6 d-none">
                <div class="d-sm-flex align-center justify-space-between">
                    <v-card-title style="font-size: 18px" class="d-none">
                        {{ title }}
                        <p v-for="(item, key) in data" :key="key">{{ item }}</p>
                    </v-card-title>
                    <!-- <template v-slot:append> -->
                    <slot name="action"></slot>
                    <!-- </template> -->
                </div>
            </v-card-item>
            <v-divider class="d-none" v-if="title || data"></v-divider>
            <v-card-text>
                <v-row v-if="isalertshow" class="mb-4">
                    <v-col cols="12">
                        <!-- Solid class, not `color="success" variant="tonal"`.
                             Tonal paints the theme colour at 12% AND draws the text
                             in that same colour; with the light theme's success
                             (#13DEB9) that renders #13DEB9 text on a #e3fbf7 panel -
                             1.08:1 against the page, 1.59:1 for its own text. The
                             message was effectively invisible. Same treatment, same
                             tokens as components/Alert.vue. -->
                        <v-alert
                            class="bs-alert bs-alert--success"
                            variant="flat"
                            :text="isalertmessage"
                            closable
                            close-label="Close Alert"
                            @click:close="closeAlert"
                        >
                        </v-alert>
                    </v-col>
                </v-row>
                <slot />
            </v-card-text>
        </v-card>
    </section>
</template>
<script>
export default {
    props: ['title', 'data', 'isalertshowdata', 'isalertmessage'],
    data() {
        return {
            items: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: './dashboard'
                }
            ],
            istitle: true,
            isalertshow: false,
            alertTimeout: null
        };
    },
    methods: {
        breadcrumb() {
            if (this.$route['meta']['title']) {
                this.items.push({
                    text: this.$route['meta']['title'],
                    disabled: true,
                    href: '#'
                });
            } else {
                this.items[0].disabled = false;
            }
        },

        closeAlert() {
            if (this.alertTimeout) {
                clearTimeout(this.alertTimeout);
            }
            this.isalertshow = false;
        }
    },
    async created() {
        this.breadcrumb();
    },
    watch: {
        isalertshowdata(val) {
            // Clear existing timeout if alert is being updated
            if (this.alertTimeout) {
                clearTimeout(this.alertTimeout);
            }

            this.isalertshow = val;

            if (val) {
                // Set timeout to auto-hide after 4 seconds
                this.alertTimeout = setTimeout(() => {
                    this.isalertshow = false;
                }, 4000);
            }
        }
    },
    mounted() {}
};
</script>

<style scoped>
/* Light fill, dark text, strong accent - matching components/Alert.vue so every
   status surface in the app reads the same.

   A light fill cannot be what makes the banner noticeable: at 0.94 alpha this
   paints #c3ddfe, only 1.39:1 against a white card. The visibility comes from
   the 6px accent bar (#1d4ed8, 6.70:1 against the page) and from text that is
   genuinely dark (#0b3b6f, 8.07:1 on the fill). White text is not an option on
   a fill this light - it measures 1.39:1.

   Alpha on the BACKGROUND COLOUR, never `opacity` on the element: `opacity`
   fades the text and icon with it, which is the exact invisibility being fixed. */
.bs-alert {
    font-size: 16px;
    border-radius: 8px !important;
    font-weight: 600;
    line-height: 1.45;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.bs-alert--success {
    background-color: rgba(191, 219, 254, 0.94) !important;
    border: 1px solid rgba(29, 78, 216, 0.45) !important;
    border-left: 6px solid #1d4ed8 !important;
    box-shadow: 0 6px 18px rgba(29, 78, 216, 0.18);
    color: #0b3b6f !important;
}

/* The close affordance lives inside VAlert's own markup, so :deep() is needed to
   reach it. It inherits a muted opacity by default, which would undo the
   contrast the text colour just bought. */
.bs-alert--success :deep(.v-alert__close),
.bs-alert--success :deep(.v-alert__close .v-btn),
.bs-alert--success :deep(.v-icon) {
    color: #0b3b6f !important;
    opacity: 1 !important;
}
</style>
